import * as yup from 'yup';
import { phoneRegExp, documentRegExp } from '../../../../../helpers/regex';
import { validateDocument } from '../../../../../helpers/validations';

const whenExistingCharge = schema => ({
  is: 'existing_charge',
  then: schema
});

const whenSameCharge = schema => ({
  is: 'same_charge',
  then: schema
});

const whenAnotherCharge = schema => ({
  is: 'another_charge',
  then: schema
});

export const chargeValidations = yup.object().shape({
  chargeType: yup
    .string()
    .required('Selecione uma opção de cobrança')
    .nullable(),
  superlogicaId: yup
    .string()
    .when('chargeType', whenExistingCharge(
      yup
        .string()
        .required('Selecione o CNPJ/cobrança existente')
        .nullable()
    ))
    .when('chargeType', whenSameCharge(
      yup
        .string()
        .required('Selecione o CNPJ/cobrança existente')
        .nullable()
    )),
  establishmentName: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O nome completo / razão social é obrigatório')
        .nullable()
    )),
  documentId: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O CNPJ/CPF é obrigatório')
        .test('documentId', 'O CNPJ/CPF precisa ser válido', value => {
          if(!value) {
            return false;
          }

          if(value.length == 14) {
            return validateDocument(value);
          }

          return documentRegExp.test(value);
        })
        .nullable()
    )),
  email: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .email('O e-mail precisa ser válido')
        .required('O e-mail de cobrança é obrigatório')
        .nullable()
    )),
  phone: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .matches(phoneRegExp, {
          message: 'O telefone precisa ser válido',
          excludeEmptyString: true
        })
        .required('O telefone de cobrança é obrigatório')
        .nullable()
    )),
  postalCode: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O CEP é obrigatório')
        .test('postalCode', 'O CEP precisa ser válido', value => {
          if(!value) {
            return false;
          }

          return String(value).replace(/\D/g, '').length == 8;
        })
        .nullable()
    )),
  street: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O endereço é obrigatório')
        .nullable()
    )),
  number: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O número é obrigatório')
        .nullable()
    )),
  complement: yup
    .string()
    .nullable(),
  district: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O bairro é obrigatório')
        .nullable()
    )),
  city: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('A cidade é obrigatória')
        .nullable()
    )),
  state: yup
    .string()
    .when('chargeType', whenAnotherCharge(
      yup
        .string()
        .required('O estado (UF) é obrigatório')
        .min(2, 'O estado (UF) não pode ter menos que 2 caracteres')
        .nullable()
    ))
});